export default {
    data() {
        var _this = this;
        var checkPassValidator = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('确认密码不能为空'));
            }
            if (value !== _this.psdForm.newPassword) {
                return callback(new Error('两次密码不一致'));
            }
            callback();
        };
        return {
            checkPassValidator: checkPassValidator,
            psdForm: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            }
        }
    },
    mounted: function() {

    },
    methods: {
        /**
         * 点击事件
         * @param {*} from 
         */
        clickEvent: function(from) {
            var _this = this;
            switch (from) {
                case "savePassword": //保存密码
                    this.$refs['psdform'].validate((valid) => {
                        if (valid) {
                            _this.requestUpdatePassword();
                        } else {
                            return false;
                        }
                    });
                    break;
            }
        },

        /**
         * 修改密码
         */
        requestUpdatePassword: function() {
            this.$post({
                url: 'user/updatePassword',
                params: {
                    oldPassword: this.$md5(this.psdForm.oldPassword),
                    newPassword: this.$md5(this.psdForm.newPassword)
                }
            }, true).then(response => {
                this.psdForm.oldPassword = "";
                this.psdForm.newPassword = "";
                this.psdForm.confirmPassword = "";
                this.$message.closeAll();
                this.$message.success("修改成功");
            });
        }
    }
};